// Shared top bar — identical shell on EVERY surface (design board v3.3):
// brand · region pills · environment pills · screen-specific context selectors
// (children) · data-as-of + Refresh · theme toggle.
//
// The two product rules it enforces by construction:
//   - No auto-refresh: data changes only via the Refresh button (or a filter
//     change) — the bar SHOWS when the data was fetched, in UTC.
//   - Filters live in one row above everything they scope, never per-chart.
import PillGroup from './PillGroup';
import Logo from './Logo';
import { utcHm } from '../../lib/format';

export default function TopBar({
  // locality pills (MCIP-23 surface; options from lib/locality.localityOptions)
  regions = null, region = null, onRegion = null,
  environments = null, environment = null, onEnvironment = null,
  // freshness: when the data on screen was fetched + the only way to refetch it
  asOf = null, onRefresh = null, refreshing = false,
  // theme
  mode, onMode,
  // screen navigation (job view / trends / …) — one element, owned by App
  nav = null,
  // screen-specific context selectors (job/run/scope/window…)
  children,
}) {
  const hasLocality = (regions && onRegion) || (environments && onEnvironment);
  const hasFilters = Boolean(nav) || hasLocality || Boolean(children);

  return (
    <header className="topbar">
      <div className="topbar__brand">
        <Logo size={18} />
        <span>CI Intelligence</span>
      </div>

      {/* Screen nav + locality + context selects share one .field row so every
          control (pills and <select>s) sits on the same baseline. */}
      {hasFilters && (
        <div className="topbar__filters">
          {nav && (
            <div className="field">
              <span>Screen</span>
              {nav}
            </div>
          )}
          {regions && onRegion && (
            <div className="field">
              <span>Region</span>
              <PillGroup label="Region" options={regions} value={region} onChange={onRegion} format={(v) => v.toUpperCase()} />
            </div>
          )}
          {environments && onEnvironment && (
            <div className="field">
              <span>Environment</span>
              <PillGroup label="Environment" options={environments} value={environment} onChange={onEnvironment} />
            </div>
          )}
          {children}
        </div>
      )}

      <div className="topbar__right">
        {asOf && (
          <span className="topbar__asof" title="data changes only when you refresh — no polling">
            data as of {utcHm(asOf)} UTC
          </span>
        )}
        {onRefresh && (
          <button type="button" className="ghost-btn" onClick={onRefresh} disabled={refreshing}>
            {refreshing ? 'Refreshing…' : 'Refresh'}
          </button>
        )}
        <button
          type="button"
          className="ghost-btn"
          onClick={() => onMode(mode === 'dark' ? 'light' : 'dark')}
          aria-label={`Switch to ${mode === 'dark' ? 'light' : 'dark'} mode`}
        >
          {mode === 'dark' ? 'Light' : 'Dark'}
        </button>
      </div>
    </header>
  );
}
